<div *ngIf="person" class="person">
    <h6>{{ title }}</h6>
    <div>
        {{ person.fullname }}&nbsp;&nbsp;&nbsp;<a [href]="person.linkedin"><fa-icon [icon]="linkedin"></fa-icon></a>
    </div>
    <div>{{ person.phone }}</div>
    <div><a [href]="mailto">{{ person.email }}</a></div>
</div>